import { render, staticRenderFns } from "./LossReasonSelect.vue?vue&type=template&id=256a9152"
import script from "./LossReasonSelect.vue?vue&type=script&lang=js"
export * from "./LossReasonSelect.vue?vue&type=script&lang=js"
import style0 from "./LossReasonSelect.vue?vue&type=style&index=0&id=256a9152&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports